import { EntityIcon } from '@components/core-ui/EntityIcon/';
import { Actions } from '@components/core-ui/UniversalCard/components/Actions';
import { TAction } from '@components/core-ui/UniversalCard/types/TAction';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { usePageContext } from '../../../../providers/PageProvider';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { StyledLink } from './styles/StyledLink';
import { Wrapper } from './styles/Wrapper';
import { AdminUserDetailsResultDto } from 'app/API';

type TProps = {
  user: AdminUserDetailsResultDto;
};

export const Organizations = ({ user }: TProps) => {
  const { me } = useAuthContext();
  const { fetchData } = usePageContext();
  const { openModal, closeModal } = useModalContext();

  if (!user) {
    return null;
  }

  const isOwnPage = me?.id === user.id;
  const hasOtherOrganizations = (user.orgRelations ?? []).length > 1;

  const onDeleteClick = (organization: AdminUserDetailsResultDto['orgRelations'][0]) => {
    openModal(ModalNamesEnum.AdminLeaveOrganizationModal, {
      organizationId: organization.id,
      organizationName: organization.name || organization.slug,
      onSuccess: () => {
        fetchData();
        closeModal();
      },
    });
  };

  const buildActions = (organization: AdminUserDetailsResultDto['orgRelations'][0]): TAction[] => {
    const actions: TAction[] = [{ label: 'Details', link: routes.adminOrganizationDetails.make(organization.id) }];
    if (isOwnPage && hasOtherOrganizations && organization.userCount > 1) {
      actions.push({ label: 'Delete', className: 'red', onClick: () => onDeleteClick(organization) });
    }
    return actions;
  };

  const renderOrganization = (organization: AdminUserDetailsResultDto['orgRelations'][0]) => {
    return (
      <div className="organization" key={organization.id}>
        <StyledLink to={routes.adminOrganizationDetails.make(organization?.id)}>
          <EntityIcon
            className="organization-shortName"
            name={organization.name || organization.slug}
            src={organization.image ?? undefined}
          />
        </StyledLink>
        <div className="organization-right">
          <div className="organization-name">
            <StyledLink to={routes.adminOrganizationDetails.make(organization?.id)}>{organization.name}</StyledLink>
          </div>
          <div className="organization-usersCount">
            {organization.userCount} {organization.userCount === 1 ? 'member' : 'members'}
          </div>
        </div>
        <div className="organization-actions">
          <Actions actions={buildActions(organization)} />
        </div>
      </div>
    );
  };

  return (
    <Wrapper>
      <LeftSide>
        <h3>Organization memberships</h3>
      </LeftSide>

      <RightSide>{(user.orgRelations ?? []).map((organization) => renderOrganization(organization))}</RightSide>
    </Wrapper>
  );
};
